<template>
  <div
    id="app"
    class="pagewrap"
    :class="[
      { 'is-scrollable' : isScrollable && !isScrolledToEnd },
      $route.meta.appClass
    ]"
    v-resize:debounce.50="updateScrollableState"
    ref="appcontainer"
  >
    <Header />
    <router-view />
    <Progressbar v-if="showProgress" />
    <OverlayBG />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import OverlayBG from "./components/OverlayBG.vue";
import Progressbar from "./components/Progressbar.vue";
import resize from "vue-resize-directive";

export default {
  name: "app",
  directives: {
    resize
  },
  components: {
    Header,
    Progressbar,
    OverlayBG
  },
  data() {
    return {
      isScrollable: false,
      isScrolledToEnd: false
    };
  },
  methods: {
    isAppScrollable() {
      return document.documentElement.clientHeight < this.$refs.appcontainer.offsetHeight;
    },
    isAppScrolledToEnd() {
      let elementScrollHeight = document.documentElement.offsetHeight;
      let windowHeight = window.innerHeight;
      let y = document.documentElement.scrollTop;
      let offset = 56;
      return y + offset + windowHeight >= elementScrollHeight;
    },
    updateScrollableState() {
      this.isScrollable = this.isAppScrollable();
      this.isScrolledToEnd = this.isAppScrolledToEnd();
    }
  },
  computed: {
    showProgress() {
      let excludeViews = ["home"];
      return excludeViews.indexOf(this.$route.name) == -1;
    }
  },
  mounted() {
    this.updateScrollableState();
  },
  updated() {
    this.updateScrollableState();
  },
  created () {
    window.addEventListener('scroll', this.updateScrollableState);
    window.addEventListener('resize', this.updateScrollableState);
  }
};
</script>
